<template>
  <div class="student-details">
    <TableLayout>
      <template slot="search-form">
        <div class="top-identify-content">
          <div class="back-btn">
            <el-button type="primary" plain @click="close" size="small">返回</el-button>
          </div>
          <div class="bold-type above margin-rgt">
            {{ studentInformation.grade.levelNum }}{{ studentInformation.grade.name }}
            （{{studentInformation.grade.profressionName}}）
          </div>
          <div v-if="studentInformation.endStatus === 1" class="bold-type above">
            距离结课还剩<span style="margin: 0 8px;color: #1E87F1;">{{studentInformation.remainingDays}}</span>天
          </div>
          <div v-else-if="studentInformation.endStatus === 0" class="bold-type above">已结课</div>
          <div class="fl">
            <span class="bold-type-stu">学生信息：</span>
            <el-button style="color: #67C23A" type="text" icon="el-icon-download" @click="downloadTemplate">下载模板</el-button>
            <el-button type="success" size="mini" :loading="importLoading" @click="handleBulkImport">批量导入</el-button>
          </div>
        </div>
        <section class="btn-actions">
          <div class="fl">
            <el-form ref="searchForm" slot="search-form" :model="searchForm" label-width="70px" inline>
              <el-form-item label="姓名" prop="name">
                <el-input v-model="searchForm.name" placeholder="请输入" clearable size="medium" class="item-width" @keyup.enter.native="search()"></el-input>
              </el-form-item>
              <el-form-item label="手机号" prop="number">
                <el-input v-model="searchForm.mobile" placeholder="请输入" clearable size="medium" class="item-width" @keyup.enter.native="search()"></el-input>
              </el-form-item>
              <section style="">
                <div class="search-btn" @click="search()" >搜索</div>
              </section>
            </el-form>
          </div>
          <div class="fr">
            <el-button size="small" type="danger" @click="handleDeleteStudent" :disabled="!multipleSelection.length">删除学生</el-button>
            <el-button size="small" type="primary" @click="handleAddStudent">新增学生</el-button>
          </div>
        </section>
      </template>
      <!-- 表格和分页 :height="tableHeight - (showObj ? 34 : 0)" -->
      <template slot="table-wrap">
        <el-table ref="tableList" :height="tableHeight" :row-style="selectedstyle" :row-class-name="tableRowClassName" :header-cell-style="{background:'#1e87f1', color:'#fff'}"
          v-loading="isWorking.loading" :data="tableData.list"
          @selection-change="handleSelectionChange"
        >
          <el-table-column type="selection" width="55"></el-table-column>
          <el-table-column prop="studentNo" label="学号" align="center"></el-table-column>
          <el-table-column prop="name" label="姓名" align="center"></el-table-column>
          <el-table-column label="性别" align="center">
            <template slot-scope="{ row }"> <span>{{ row.gender === 0 ? '男' : row.gender === 1 ? '女' : '' }}</span> </template>
          </el-table-column>
          <el-table-column prop="account" label="手机号" align="center"></el-table-column>
          <el-table-column label="注册时间" align="center">
            <template slot-scope="{ row }"><span>{{ formatDate(row.createTime) }}</span></template>
          </el-table-column>
          <el-table-column label="操作" align="center" width="320px">
            <template slot-scope="{ row }">
              <el-button type="text" @click="handleEditStudent(row)">修改信息</el-button>
              <el-button type="text" @click="handleResetPassword(row)">重置密码</el-button>
              <el-button type="text" @click="handleChangeClass(row)">更换班级</el-button>
              <el-button type="text" @click="studyDetails(row)">查看详情</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="fix-footer">
          <pagination
            @size-change="handleSizeChange"
            @current-change="handlePageChange($event, { msg: true })"
            :pagination="tableData.pagination"
          ></pagination>
        </div> -->
      </template>
    </TableLayout>
    <Dialog :title="dialogTitle" :visible.sync="dialogVisible" @dialog-confirm="dialogHandleConfirm" >
      <el-form ref="dialogForm" :model="dialogForm" label-width="70px" class="class-form" label-position="left">
        <template v-if="dialogType === dialogTypeArr[0] || dialogType === dialogTypeArr[1]">
          <el-row>
            <el-col :span="11">
              <el-form-item label="学号" prop="number" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-input style="width:100%" placeholder="请输入学号" show-word-limit size="small" maxlength="20" v-model="dialogForm.number"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label="姓名" prop="name" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-input placeholder="请输入姓名" show-word-limit size="small" maxlength="20" v-model="dialogForm.name"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="11">
              <el-form-item label="性别" prop="gender" class="inline-item" :rules="{ required: true, message: ' ', trigger: 'blur' }">
                <el-select style="width:100%" placeholder="请选择性别" size="small" v-model="dialogForm.gender" >
                  <el-option label="男" value="male" ></el-option>
                  <el-option label="女" value="female" ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="11" :offset="2">
              <el-form-item label="手机号" prop="phone" class="inline-item" :rules="phoneRule">
                <el-input placeholder="请输入手机号" show-word-limit size="small" maxlength="11" v-model="dialogForm.phone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </template>
        <template v-else-if="dialogType === dialogTypeArr[3]">
          <div class="class-change-prompt">请注意：一旦该学员更换班级，其所有课程历史数据将被清空，请谨慎操作。</div>
          <el-form-item label="班级" prop="classId" :rules="{ required: true, message: ' ', trigger: 'blur' }">
            <el-select style="width:100%" placeholder="请选择班级" v-model="dialogForm.classId" filterable>
              <!-- <el-option v-for="item in classNameOptions" :key="item.id" :label="item.name" :value="item.id" :disabled="item.id === classId"></el-option> -->
              <el-option v-for="item in classNameOptions" :key="item.id" :label="item.levelName + item.name" :value="item.id"></el-option>
            </el-select>
          </el-form-item>
        </template>
      </el-form>
    </Dialog>
    <el-dialog class="import-dialog" title="批量导入" :visible.sync="importDialogVisible" @close="importDialogClose">
      <el-upload
        class="upload-demo"
        drag action=""
        :http-request="bulkImport" accept="application/vnd.ms-excel,.xlsx"
        :multiple="false"
        :show-file-list="false"
        >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
        <div class="el-upload__tip" slot="tip">只能上传xlsx文件，且不超过10M</div>
      </el-upload>
      <div v-if="importIsError" class="error-message">
        <div class="title">需修改学生</div>
        <div class="content" style="white-space: pre-wrap;">{{this.importErrorList}}</div>
        <div class="tips">除以上学生信息外，其他学生信息已上传完成！</div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { comMethod } from '@/utils/index.js'
import Pagination from '@/components/common/pagination'
import Dialog from '../Dialog';
import BaseTable from '@/components/BaseTable'
import TableLayout from '@/layout/TableLayout'
import { formatDate } from '@/utils/formatDate.js';
import { classServer, studentServer } from '@/api/api';
export default {
  name: 'StudentDetails',
  extends: BaseTable,
  components: { TableLayout, Pagination, Dialog },
  data () {
    return {
      tableHeight: 300,
      searchForm: {
        name: '',
        mobile: ''
      },
      classId: this.$route.query.id,
      studentId: '',
      studentInformation: {
        grade: { levelNum: '', profressionName: '', name: '' }
      },
      classNameOptions: [],
      dialogTypeArr: ['addStudent', 'editStudent', 'resetPassword', 'changeClass'],
      dialogTitle: '新增学生',
      dialogType: 'newStudent',
      dialogVisible: false,
      dialogForm: {
        number: '',
        name: '',
        gender: '',
        phone: '',
        // className: '',
        // classId: this.$route.query.id
        classId: ''
      },
      importLoading: false,
      importDialogVisible:false,
      importIsError: false,
      importErrorList: [],
      phoneRule: this.setFormOptions().phoneRule,
      multipleSelection: []
    }
  },
  created () {
    this.getStudentInformation();
    // this.search();
    // this.tableHeight = comMethod.getTableHeight(308);
    // this.tableHeight = comMethod.getTableHeight(265);
    this.tableHeight = comMethod.getTableHeight(308);
    this.initDialogFormData();
  },
  methods: {
    formatDate,
    initDialogFormData() {
      this.dialogForm = {
        number: '',
        name: '',
        gender: null,
        phone: '',
        // className: '',
        // classId: this.classId
        classId: '',
      };
    },
    validateForm(formName) {
      return new Promise( resolve => {
        this.$refs[formName].validate( valid => {
          if (valid) {
            resolve(true);
          } else {
            this.$message.error('请检查必填项');
            resolve(false);
          }
        });
      });
    },
    setFormOptions() {
      return {
        phoneRule: [
          {
            required: true,
            validator: (rule, value, callback) => {
              const phoneReg = /^1[3-9]\d{9}$/;
              if (!value) {
                callback(new Error(" "));
              } else if (!phoneReg.test(value)) {
                callback(new Error("请输入正确的11位手机号"));
              } else {
                callback();
              }
            },
            trigger: ["blur", "change"]
          }
        ]
      }
    },
    async getStudentInformation() {
      try {
        const res = await classServer.classStudentDetail({ gradeId: this.classId });
        const { code, data, message } = res;
        if (code === '0') {
          this.studentInformation = data;
          this.tableData.list = data.gradeUserList;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    // 获取学生数据
    async getStudentList() {
      try {
        const res = await classServer.classStudentQuery({ ...this.searchForm, gradeId: this.classId });
        const { code, data, message } = res;
        if (code === '0') {
          this.tableData.list = data;
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    handleAddStudent() {
      this.dialogTitle = '新增学生';
      this.dialogType = this.dialogTypeArr[0];
      this.initDialogFormData();
      this.handleOpenDialog();
    },
    async handleDeleteStudent() {
      try {
        await this.$confirm('请确认是否删除该学生数据，一旦删除，该学生数据将全部清空！', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
        await this.deleteStudent();
      } catch (error) { }
    },
    async handleEditStudent(row) {
      this.studentId = row.id;
      const backendData = await this.queryStudentById();
      if(!backendData) return;
      this.dialogTitle = '修改信息';
      this.dialogType = this.dialogTypeArr[1];
      this.initDialogFormData();
      let form = {
        number: backendData.studentNo,
        name: backendData.name,
        gender: backendData.gender === 0 ? 'male' : 'female',
        phone: backendData.account
      };
      this.dialogForm = { ...this.dialogForm, ...form };
      this.handleOpenDialog();
    },
    async handleResetPassword(row) {
      this.studentId = row.id;
      try {
        await this.$confirm('确定要重置该学生的密码吗？', '提示', {
          type: 'warning',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        });
        await this.resetPassword();
      } catch (error) { }
    },
    async handleChangeClass(row) {
      this.studentId = row.id;
      await this.getClassName();
      this.dialogTitle = '更换班级';
      // this.dialogForm.classId = this.classId;
      this.dialogType = this.dialogTypeArr[3];
      this.handleOpenDialog();
    },
    handleOpenDialog() {
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.dialogForm?.clearValidate();
      });
    },
    studyDetails (row) {
      this.rowIndex = row.index;
      let rourteUrl = this.$router.resolve({
        path: 'StudyDetails',
        query: { id: row.id }
      });
      window.open(rourteUrl.href, '_blank');
    },
    async dialogHandleConfirm() {
      let valid = await this.validateForm('dialogForm');
      if(!valid) return;
      this.dialogVisible = false;
      switch (this.dialogType) {
        case this.dialogTypeArr[0]:
          await this.addStudent();
          break;
        case this.dialogTypeArr[1]:
          await this.editStudent();
          break;
        case this.dialogTypeArr[2]:
          await this.resetPassword();
          break;
        case this.dialogTypeArr[3]:
          await this.changeClass();
          break;
        default:
          break;
      }
    },
    initBackendForm() {
      return {
        name: this.dialogForm.name,
        studentNo: this.dialogForm.number,
        gender: this.dialogForm.gender === 'male' ? 0 : this.dialogForm.gender === 'female' ? 1 : null,
        mobile: this.dialogForm.phone,
        gradeId: this.classId
      }
    },
    async queryStudentById() {
      const res = await studentServer.studentDetail({ userId: this.studentId });
      return res.data || null;
    },
    async addStudent() {
      const form = this.initBackendForm();
      try {
        const res = await studentServer.studentAdd({ ...form });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async deleteStudent() {
      const userIds = this.multipleSelection.map(item => item.id).join(',');
      try {
        const res = await classServer.deleteStudents({ userIds });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error);
      }
    },
    async editStudent() {
      const form = this.initBackendForm();
      try {
        const res = await studentServer.studentUpdate({...form, id: this.studentId });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async resetPassword() {
      try {
        const res = await studentServer.studentResetPassword({ userId: this.studentId });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async changeClass() {
      try {
        const res = await studentServer.studentChangeClass({
          userId: this.studentId,  
          gradeId: this.dialogForm.classId
        });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    async getClassName () {
      try {
        const res = await classServer.classNameList();
        const { code, data, message } = res;
        if (code === '0') {
          this.classNameOptions = data.filter(item => item.id !== this.classId);
        } else {
          this.$message.error(message);
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    downloadTemplate() {
      window.location.href = `/file/学生注册模板.xlsx`;
    },
    handleBulkImport() {
      this.importDialogVisible = true;
    },
    async bulkImport(data) {
      // this.importLoading = true;
      let formData = new FormData();
      formData.append('file', data.file);
      formData.append('gradeId', this.classId);
      try {
        const res = await studentServer.studentImport(formData);
        // const res = await studentServer.studentImport({ gradeId: this.classId, file: data.file });
        const { code, data, message } = res;
        if (code === '0') {
          this.$message.success(message);
          this.getStudentList();
          this.importDialogVisible = false;
          this.importDialogClose();
        } else if(code === '1') {
          this.$message.error(message);
          this.importDialogVisible = false;
          this.importDialogClose();
        } else { //手机号重复
          this.$message.error('导入失败');
          this.importIsError = true;
          this.importErrorList = message.replace(/null/g, '  ');
        }
      } catch (error) {
        this.$message.error(error.response.data.message || error);
      }
    },
    importDialogClose() {
      this.importIsError = false;
      this.importErrorList = [];
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    /**
     * 页码变更处理
     * @function handlePageChange
     * @param { Interger } pageIndex 搜索页面
     * @param { Object } obj 搜索处理逻辑内容
     */
    handlePageChange (pageIndex, obj = {}) {
      this.getStudentList();
    },
    handleChange(value) {
      // 手动收起下拉框
      this.$nextTick(() => {
        this.$refs.cascader.dropDownVisible = false; // 收起下拉框
      })
    },
    keyDownEnter (e) {
      var keyCode = window.event ? e.keyCode : e.which;
      if (keyCode === 13) {
        this.search();// 搜索按钮的回调
      }
    },
    close() {
      window.close();
    }
  }
}
</script>

<style lang="scss" scoped>
.student-details .btn-actions {
  .search-btn {
    display: inline-block;
    width: 60px;
    height: 32px;
    border-radius: 8px;
    cursor: pointer;
    border: 1px solid #D0DFFB;
    color: #0052D9;
    font-family: PingFang SC;
    font-size: 14px;
    line-height: 30px;
    margin-left: 2px;
    text-align: center;
    // &:hover {
    //   background: #0052D9;
    //   border: 1px solid #0052D9;
    //   color: #fff;
    // }
  }
  /deep/ .el-input__inner {
    font-family: PingFang SC;
    height: 32px;
    border-radius: 8px;
    border: 1px solid #D0DFFB;
    // color: #AAB4D2;
  }
  /deep/ .el-select {
    .el-input__inner {
      width: 160px;
      border-radius: 4px;
      color: #4F6389;
    }
  }
}
.student-details {
  width: 100%;
  height: 100%;
  .top-identify-content {
    padding: 10px 20px 8px 20px;
    .back-btn {
      margin-bottom: 16px;
    }
    .bold-type {
      font-size: 20px;
      font-weight: bold;
    }
    .bold-type-stu {
      font-size: 15px;
      font-weight: bold;
    }
    .above {
      margin-bottom: 10px;
      display: inline-block;
    }
    .margin-rgt {
      margin-right: 30px;
    }
  }
  .class-form {
    width: 90%;
    .class-change-prompt {
      // color: #9e2b28;
      color: red;
      margin-bottom: 27px;
    }
    .reset-password-prompt {
      // color: red;
      // font-weight: bold;
      font-size: 16px;
    }
  }
  .import-dialog {
    .error-message {
      text-align: left;
      .title {
        margin: 10px 0;
        font-size: 17px;
        font-weight: bold;
      }
      .content {
        margin: 20px;
      }
      .tips {
        font-size: 17px;
      }
    }
  }
}
</style>

<style lang="scss">
.student-details {
  .el-dialog__body, .my-scroll {
      overflow: auto;
      padding-top: 30px;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/classCenter/StudentDetails/index.vue